import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles(() => ({
  root: {},
  tabs: {},
  search: {
    paddingTop: 20,
    paddingBottom: 8,
  },
  map: {
    height: "calc(100vw * 0.68)",
  },
  controls: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 8,
    marginBottom: 20,
  },
  countries: {
    marginBottom: 24,
  },
  legend: {},
}));
